'use strict';

const ArchivePermit = require("./archive-permit");

const $ = require('jquery');
const Template = require('./../lib/template');

const $lazyLoader = $('[data-lazy-load-area]');

class FilterLazyLoad {

    constructor() {

        if ($lazyLoader.length > 0) {

            this.postType = $lazyLoader.data('post-type');
            this.$resultHolder = $lazyLoader.find('[data-results-holder]');
            this.$buttonHolder = $lazyLoader.find('[data-button-holder]');

            let $filterForm = $lazyLoader.find('[data-filter-form]');
            let $filterFormFields = $filterForm.find('input[type="checkbox"], input[type="radio"], input[type="month"], select');

            let pagedTotal = $lazyLoader.data('lazy-total');
            let paged = 1;
            let checkingForFilters = false

            //  Handle all field of the form to process the filters (taxonomies)
            $filterFormFields.on('change', async function (e) {
                const archivePermits = new ArchivePermit(true)
                
                if (archivePermits.anyFiltersOpen) {
                    if (!checkingForFilters) {
                        checkingForFilters = true

                        await archivePermits.waitForFiltersClosed()
                            .then(() => {
                                checkingForFilters = false
                                $filterForm.submit();
                            })
                    }
                } else {
                    $filterForm.submit();
                }
            });

            App.Globals.$document.on('click', '.load-more', (event) => {
                event.preventDefault();

                let href = event.currentTarget.href;
                let url = href.replace(/^.*\/\/[^\/]+/, '');
                let append = true;

                this.loadItems(url).then((data) => {
                    data.ajax = true;

                    if (this.$resultHolder.length > 0) {
                        Template.render(this.$resultHolder, `${rk_globals.theme_path}/views/parts/${this.postType}/set.twig`, data, append);
                    }

                    if (paged < pagedTotal) {
                        paged++;

                        if (this.$buttonHolder.length > 0) {
                            Template.render(this.$buttonHolder, `${rk_globals.theme_path}/views/parts/load-more.twig`, data);
                        }
                    }

                });

                event.currentTarget.parentNode.remove();
            });

        }

    }

    async loadItems(url) {
        try {
            return await $.ajax({
                url: url,
                data: {
                    json: true
                },
                dataType: 'json'
            });
        } catch (error) {
            if (App.Globals.debug) {
                console.log(error);
            }
        }
    }

}

module.exports = FilterLazyLoad;
